<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        x-large
        text
        class="rounded-lg pa-4"
        outlined
        height="auto"
        :class="contentClass"
      >
        <div class="w-100 gap-2 d-flex align-center">
          <template v-if="selectedStore">
            <v-img
              v-img
              :src="selectedStore.Brand?.logo"
              height="30"
              width="30"
              contain
              class="flex-shrink-0 flex-grow-0"
            />
            <div class="flex-grow-1 text-left">
              <div class="text-left" style="width: 176px">
                <b style="text-wrap: wrap">
                  {{ selectedStore?.Condominium?.name || "Sem Condomínio" }}
                </b>
              </div>
            </div>
          </template>
          <template v-else>
            <i>Sem loja selecionada</i>
          </template>
          <v-icon>mdi-unfold-more-horizontal</v-icon>
        </div>
      </v-btn>
    </template>
    <v-list style="max-width: 268px">
      <v-list-item
        v-for="store in stores"
        :key="store.id"
        @click="selectStore(store.id)"
      >
        <v-list-avatar class="mr-3">
          <v-img
            v-img
            :src="store.Brand?.logo"
            height="25"
            width="25"
            contain
          />
        </v-list-avatar>
        <v-list-item-title v-if="store?.Condominium" class="text-truncate">
          {{ store?.Condominium?.name }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "StoreSelector",
  props: {
    contentClass: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState("store", ["stores"]),
    ...mapGetters("store", ["selectedStore"]),
  },
  methods: {
    selectStore(storeId) {
      this.$store.dispatch("store/selectStore", storeId);
    },
  },
};
</script>
